<template>
  <eco-sidebar-dialog
    destroy-on-close
    title="角色菜单授权"
    :visible="dialogVisible"
    :before-close="handleClose"
    width="30%"
    append-to-body
  >
  <div style="padding: 20px;height: calc(100% - 40px)">
    <eco-menu-manager
      v-if="loadEnd"
      ref="ecoMenuManager"
      show-checkbox
      hide-menu
      append-to-body
      :check-strictly="true"
      :supportFilter="true"
      :default-checked-keys="defaultCheckedKeys"
      width="100%"
    />
  </div>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose()">{{
        $t("eip.common.cancel")
      }}</el-button><fe-submit-button
        url="${portal}/sys/sysRoleAuth/v1/save"
        :model="saveData"
        scope-name="editRoleMenuForm"
        @before-save-data="beforeSaveData"
        @after-save-data="afterSaveData"
        >{{ $t("eip.common.save") }}</fe-submit-button
      >
      
    </div>
  </eco-sidebar-dialog>
</template>

<script>
import req from "@/request.js";

const ecoMenuManager = () => import("@/components/system/FeMenuManager.vue");

export default {
  name: "RoleMenuAuth",
  components: {
    ecoMenuManager
  },
  props: {},
  data() {
    return {
      loadEnd: false,
      dialogVisible: false,
      roleMenusMethod: null,
      defaultCheckedKeys: [],
      saveData: {},
      roleAlias: null,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 100,
        total: 0
      }
    };
  },
  methods: {
    showDialog(roleAlias) {
      this.loadEnd = false;
      this.defaultCheckedKeys = [];
      this.dialogVisible = false;
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
      this.roleAlias = roleAlias;
      this.loadData(roleAlias);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    loadData(roleAlias) {
      // this.defaultCheckedKeys = [];
      req
        .get(
          "${portal}" +
            `/sys/sysMenu/v1/getAllMenuRoleAlias?roleAlias=${roleAlias}`
        )
        .then(response => {
          // isParent = 0 checked !=0
          response.data.forEach(element => {
            if (element.checked != 0) {
              this.defaultCheckedKeys.push(element.alias);
            }
          });
          this.loadEnd = true;
        });
    },
    beforeSaveData() {
      // saveData = {roleAlias:"",arrMenuAlias:[],arrMethodAlias:[],dataPermission:{}}
      var elTree = this.$refs.ecoMenuManager.$refs.ecoMenuTree.$refs.ecoMenuTree;
      this.saveData = {
        roleAlias: this.roleAlias,
        arrMenuAlias: [
          ...elTree.getHalfCheckedKeys(),
          ...elTree.getCheckedKeys()
        ],
        arrMethodAlias: [],
        dataPermission: {}
      };
    },
    afterSaveData() {
      this.handleClose();
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .el-dialog__body {
  padding: 0px;
}
</style>
